"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveInstanceBindingNodeAsyncFromConstructorParams = resolveInstanceBindingNodeAsyncFromConstructorParams;
function resolveInstanceBindingNodeAsyncFromConstructorParams(resolveInstanceBindingNodeFromConstructorParams) {
    return async (constructorValues, params, node) => {
        const constructorResolvedValues = await constructorValues;
        return resolveInstanceBindingNodeFromConstructorParams(constructorResolvedValues, params, node);
    };
}
//# sourceMappingURL=resolveInstanceBindingNodeAsyncFromConstructorParams.js.map